import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BoxIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createProduct } from '../../api/products/create-product'
import UserNavBar from '../../components/elements/nav-bar'
import ProductForm from '../../components/pages/products/product-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const ProductCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createProduct,
    onError: showAxiosError,
    onSuccess: () => toast.success('Produit créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un produit'} icon={BoxIcon} />
      <div className={'h-4'} />

      <Box>
        <ProductForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.PRODUCT_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default ProductCreatePage
